module.exports = __webpack_public_path__ + "static/media/vue-js.6654d099.jpg";